<style>

.card{
  position: relative;
  color: white;
}

.event-name{
  font-size: 21px;
}

.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}

img{
  object-fit: cover;
  width: 100%;
}

.like-dislike-buttons{
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 20px 0;
}
.dislike{
  grid-column: 1;
  padding: 0 20px;
}
.like{
  grid-column: 2;
  padding: 0 20px;
  text-align: right;
}
.icon-clear{
  font-size: 41px;
}
.icon-check{
  font-size: 41px;
}
button{
  border-radius: 15px;
  border-width: 1px;
  padding: 0 20px;
}
button.likeb{
  background-color: white;
  color: black;
}
button.likeb:hover{
  background-color: black;
  color: white;
}

.about-me{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 15px 10px;
}
.bio{
  margin: 10px;
}

.common-interests{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 15px 10px;
}
.common-interests-text{
  margin: 10px;
}
.show-all{
  margin: 20px;
}
button.show-all-button{
  padding: 10px 20px;
}
</style>

<Header 
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }">Find Friends</Header>
<div class="has-header"></div>


<div class="card">
  <img src="/i/julie-chen.jpg" alt="" class="img">
  
  <div class="info">
    <div class="event-name">{name} - {age}</div>
    <div>Common Interests: {interests}%</div>
  </div>
</div>

<div class="like-dislike-buttons">
  <div class="dislike"> <button> <i class="icon-clear"></i> </button> </div>
  <div class="like"> <button class="likeb"> <i class="icon-check"></i> </button> </div>
</div>

<VennMatch match="{85}"></VennMatch>

<div class="about-me">About Me</div>
<div class="bio">I really like sitting.  I like sitting so much that people usually comment how much I'm sitting.</div>

<div class="common-interests">Common Interests</div>
<div class="common-interests-text">
  Sitting<br>
  Sitting<br>
  Sitting
</div>

<div class="show-all"> <button class="show-all-button" on:click="{ () => push('/friends') }">Show All Friends</button> </div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import VennMatch from "../components/VennMatch.svelte";

let name = "Julie Chen";
let age = 25;
let interests = 85;

</script>